export default __webpack_public_path__ + "static/media/promoterHeader.e1dfa2d9.svg";